import { createStore, compose, combineReducers } from 'redux';
import authReducer from './reducers/authReducer';
import userActivityReducer from './reducers/userActivityReducer';
import sessionTimeOutModalReducer from './reducers/sessionTimeOutModalReducer';
import globalizationReducer from './reducers/globalizationReducer';

const initialState = {
};

const rootReducer = combineReducers({
  auth: authReducer,
  userActivity: userActivityReducer,
  modal: sessionTimeOutModalReducer,
  globalization: globalizationReducer,
});

const composeEnhancers = (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(),
);

export default store;
